import { render, staticRenderFns } from "./SubjectList.vue?vue&type=template&id=cc0bf3dc&scoped=true&"
import script from "./SubjectList.vue?vue&type=script&lang=js&"
export * from "./SubjectList.vue?vue&type=script&lang=js&"
import style0 from "./SubjectList.vue?vue&type=style&index=0&id=cc0bf3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0bf3dc",
  null
  
)

export default component.exports